export default () => ({
  dialog: false,
  product: null,
  offer: null,
  isFirstOffer: false,
  justAcceptedOffer: false,
  decreasingCounterOffer: false,
  maxCounterOffer: null,
  currentView: 'warning', // 'warning' or 'confirm' or 'accepted',
  buyer: null

})
